import {
  DashboardActionTypes,
  PeriodTotalSummary,
  StorePeriodSummary,
  TotalSummary,
} from "./dashboardTypes";

export const getCurrentGroupSummaryAction = (summary: TotalSummary) => ({
  type: DashboardActionTypes.GET_CURRENT_GROUP_SUMMARY,
  payload: summary,
});

export const getCurrentStoreSummaryAction = (summary: TotalSummary) => ({
  type: DashboardActionTypes.GET_CURRENT_STORE_SUMMARY,
  payload: summary,
});

export const postToSearchGroupPeriodSummaryAction = (
  summary: PeriodTotalSummary
) => ({
  type: DashboardActionTypes.POST_TO_SEARCH_GROUP_PEROID_SUMMARY,
  payload: summary,
});

export const postToSearchStorePeriodSummaryAction = (
  summary: StorePeriodSummary
) => ({
  type: DashboardActionTypes.POST_TO_SEARCH_STORE_PEROID_SUMMARY,
  payload: summary,
});
